__turbopack_context__.v({
  "body": "bondScreenerDeleteViewModal-module-scss-module__jO0gjW__body",
  "content": "bondScreenerDeleteViewModal-module-scss-module__jO0gjW__content",
  "description": "bondScreenerDeleteViewModal-module-scss-module__jO0gjW__description",
  "title": "bondScreenerDeleteViewModal-module-scss-module__jO0gjW__title",
});
